import PageHeader from "@/ui/components/PageHeader";
import { changelogEntries, formatChangelogDate } from "@/data/changelog";

export default function BlogPage() {
  const posts = changelogEntries.map((post) => (
    <article key={post.date} className="mt-6">
      <h2 className="text-lg font-semibold text-gray-900">{post.title}</h2>
      <time dateTime={post.date} className="text-sm text-gray-500">
        {formatChangelogDate(post.date)}
      </time>
      <ul className="mt-2 list-disc pl-5 text-gray-700">
        {post.changes.map((change) => (
          <li key={change.description}>
            {change.description}
            {change.relatedPage && (
              <>
                {" "}
                <a
                  href={change.relatedPage.href}
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  {change.relatedPage.label}
                </a>
              </>
            )}
          </li>
        ))}
      </ul>
    </article>
  ));

  return (
    <div className="mt-4 px-4 sm:px-6 lg:px-8">
      <PageHeader
        title="Changelog and Updates"
        description="What's new in Idle Efficiency, the Milky Way Idle profit calculator."
      />
      <div className="mx-auto max-w-3xl">{posts}</div>
    </div>
  );
}
